import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import newGroup from '@editor/page/top-control-bar/dynamic-data/groups/new-group';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import GroupItemOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('group-item', {
  template: require('./template.html'),
  name: 'group-item',
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentSite',
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
      'globalOpenModal',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    activeSiteType() {
      return this.droplet.siteType || this.currentSite.type;
    },
    groupItem() {
      const { dynamic } = this.currentSite;
      const enabled = (dynamic && dynamic[this.activeSiteType]) || {};
      const items = enabled ? (enabled.groups || []) : [];
      const ref = this.droplet.groupId;
      const item = ref && enabled ? _.find(items, p => p._id === ref) : false;
      return item || Object.assign(newGroup({
        name: 'No Group Linked',
        alias: 'No Group Linked',
      }), { _placeholder: true });
    },
    feed() {
      const feed = _.cloneDeep(this.groupItem.items);
      const { dynamic } = this.currentSite;
      const enabled = (dynamic && dynamic[this.activeSiteType]) || {};
      const published = _.cloneDeep(enabled.published || []);
      return _.map(feed, (_id) => {
        const item = _.find(published, item => item._id === _id);
        if (item && item.thumbnail) {
          item.thumbnail = this._servePrefix(item.thumbnail) + item.thumbnail;
        }
        if (item && item.image) {
          item.image = this._servePrefix(item.image) + item.image;
        }
        return item || {};
      });
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzGroupItem' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        searchBrdrWidthTop: null,
        searchBrdrWidthBottom: null,
        searchBrdrWidthLeft: null,
        searchBrdrWidthRight: null,
        searchBrdrRadiusTopRight: null,
        searchBrdrRadiusTopLeft: null,
        searchBrdrRadiusBottomRight: null,
        searchBrdrRadiusBottomLeft: null,
        searchLetterSpacing: null,
        barRadiusTopRight: null,
        barRadiusTopLeft: null,
        barRadiusBottomRight: null,
        barRadiusBottomLeft: null,
        groupImgWidth: null,
        groupImgBrdRightWidth: null,
        groupImgBrdLeftWidth: null,
        groupImgBrdTopWidth: null,
        groupImgBrdBottomWidth: null,
        groupImgBrdTrRadius: null,
        groupImgBrdTlRadius: null,
        groupImgBrdBrRadius: null,
        groupImgBrdBlRadius: null,
        groupNameSpacing: null,
        groupNameSize: null,
        fbPaddingTop: null,
        fbPaddingBottom: null,
        fbPaddingLeft: null,
        fbPaddingRight: null,
        'box-shadow': null,
        'letter-spacing': null,
        'border-top-width': null,
        'border-bottom-width': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-right-radius': null,
        'border-top-left-radius': null,
        'border-bottom-right-radius': null,
        'border-bottom-left-radius': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    GroupItemOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzGroupItem',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    globalOpenModal(open) {
      if (!open) {
        // we trigger the rerender here if user is adding new group data
        this.destroyPlugin();
        this.initPlugin();
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    this.initPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
    destroyPlugin() {
      const $droplet = $(this.$refs.groupItemGrid);
      if ($droplet.drzFilterGrid.destroy) {
        $droplet.drzFilterGrid.destroy($droplet);
      }
    },
    initPlugin() {
      const $droplet = $(this.$refs.groupItemGrid);
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic[this.activeSiteType];
      const categories = enabled ? enabled.categories : [];
      const customCategories = this.droplet.customCategories;
      let filters = false;
      if (!this.droplet.hideFilters && !this.droplet.customList && categories.length > 0) {
        filters = categories;
      }
      if (!this.droplet.hideFilters && this.droplet.customList && customCategories.length > 0) {
        filters = customCategories;
      }
      let feed = this.feed;
      if (this.droplet.customList) {
        feed = feed.filter(p => customCategories.some(f => p.categories.indexOf(f) >= 0));
      }
      $droplet.drzFilterGrid({
        output(data) {
          return `
            <div class="drzGroupItem-grid-card">
              <a class="drzGroupItem-grid-cardInner" href="${data.pageLink || '#'}">
                <div class="drzGroupItem-grid-cardImage">
                  <img class="drzGroupItem-grid-cardImg" data-asset="${data.thumbnail || data.image}" />
                </div>
                <div class="drzGroupItem-grid-cardInfo">
                  <span class="drzGroupItem-grid-cardTitle">${data.title || data.name}</span>
                </div>
              </a>
            </div>
          `;
        },
        onRender($card) {
          const $link = $card.find('.drzGroupItem-grid-cardInner');
          $link.click(e => e.preventDefault());
        },
        filters,
        match: 'all',
        pagination: this.droplet.paginate,
        sortKey: this.droplet.sortKey,
        sort: this.droplet.sort,
        filterText: this.droplet.filterText,
        searchKeys: ['title', 'name', 'alias'],
        feed,
        gridContainer: 'drzGroupItem-grid-container',
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/group-item/index.js